if (!BEditor.ToolbarsManager)
{
  BEditor.ToolbarsManager = new ToolbarsManager();

  //// TODO: DIME
  if (BEditor.AdminPanel)
  {
    BEditor.AdminPanel.AdminPanelReady.addHandler(BEditor.ToolbarsManager.init);
  }
  else
  {
    BEditor.domHandlers.addPageParsedHandler(BEditor.ToolbarsManager.init);
  }

}

if (!BEditor.PublicToolbarsManager)
{
  BEditor.ToolbarPublicManager = new ToolbarsManager();
}


export default function ToolbarsManager(isPublicAdminToolbar)
{
  var pThis = this,
      typeName = 'BEditor.ToolbarsManager';

  pThis.init = init;

  pThis.toString = function () { return typeName; };

  var topWin = BEditor.environment.topWindow,
      isToolbarConfigApplied = false,
      isLocalToolbar = false;

  pThis.checkIfToolbarReady = function ()
  {
    return (pThis.toolbar.isObjValid == 2);
  };


  pThis.createToolbar = function (tWindow, idMainContainer, pToolbarStruct, args = {})
  {
    var i,
      isReactComponentEditor = !!args.isReactComponentEditor;

    isLocalToolbar = !!args.isLocalToolbar;

    if (!isPublicAdminToolbar && isLocalToolbar && (tWindow == BEditor.environment.topWindow.contentarea || isReactComponentEditor))
    {
      if (!tWindow.BonaDialog)
      {
        tWindow.BonaDialog = BEditor.environment.topWindow.BonaDialog;
      }

      if (!BEditor.LocalToolbarManager)
      {
        BEditor.LocalToolbarManager = new ToolbarsManager(true);
        BEditor.LocalToolbarDropdowns = [];
      }

      for (i = 0; i < BEditor.LocalToolbarDropdowns.length; i++)
      {
        BEditor.LocalToolbarDropdowns[i].dropdown.DropDownShowed.removeHandler(BEditor.LocalToolbarDropdowns[i].handlerShowed);
        BEditor.LocalToolbarDropdowns[i].dropdown.DropDownHidden.removeHandler(BEditor.LocalToolbarDropdowns[i].handlerHidden);
      }

      BEditor.LocalToolbarDropdowns.splice(0, BEditor.LocalToolbarDropdowns.length);

      var toolbarConfigName = 'BEditor.environment.topWindow.' + pToolbarStruct;

      return BEditor.LocalToolbarManager.createToolbar(isReactComponentEditor ? BEditor.environment.topWindow : BEditor.environment.topWindow.contentarea, idMainContainer, toolbarConfigName, args);
    }

    var mainContainer = tWindow.document.getElementById(idMainContainer);

    if (BEditor.EditorsManager.getBrowserIsValid())
    {
      if (!pThis.toolbar || isPublicAdminToolbar)
      {
        if (mainContainer)
        {
          mainContainer.style.display = 'block';
        }

        pThis.toolbar = new BEditor.Toolbar(tWindow, idMainContainer, pToolbarStruct, args);
      }

      pThis.isToolbarWaitingShow = true;

      return pThis.toolbar;
    }
    else
    {
      if (mainContainer)
      {
        mainContainer.style.display = 'none';
      }

      return null;
    }
  };


  pThis.configurateToolbar = function (toolbarConfig, isLocalToolbar)
  {
    if (isLocalToolbar)
    {
      if (BEditor.LocalToolbarManager)
      {
        BEditor.LocalToolbarManager.configurateToolbar(toolbarConfig);
      }
    }
    else if (!isToolbarConfigApplied)
    {
      if (pThis.toolbar && pThis.toolbar.isObjValid == 2 && ((typeof(toolbarConfig) === 'string') ? window[toolbarConfig] : toolbarConfig))
      {
        isToolbarConfigApplied = true;
        pThis.toolbar.configurateToolbar((typeof(toolbarConfig) === 'string') ? window[toolbarConfig] : toolbarConfig);
      }
      else
      {
        setTimeout(function () { pThis.configurateToolbar(toolbarConfig, isLocalToolbar) }, 100);
      }
    }
  };


  pThis.showToolbar = function ()
  {
    if (pThis.toolbar)
    {
      if (pThis.toolbar.isObjValid)
      {
        if (isPublicAdminToolbar || !(isLocalToolbar && BEditor.isPageAdminViewMode()))
        {
          pThis.toolbar.showToolbar();
        }
      }
      else
      {
        setTimeout(pThis.showToolbar, 100);
      }
    }
  };


  pThis.hideToolbar = function ()
  {
    if (pThis.toolbar)
    {
      isToolbarConfigApplied = false;
      pThis.toolbar.hideToolbar();
    }
  };


  pThis.switchToolbar = function ()
  {

  };


  function showHideEditorToolBar(sender, args)
  {
    if (args === BEditor.AdminPanel.PageModeType.Edit)
    {
      BEditor.ToolbarsManager.showToolbar();
    }
    else
    {
      BEditor.ToolbarsManager.hideToolbar();
    }
  }


  function init()
  {
    //// TODO: DIME
    if (BEditor.AdminPanel && BEditor.AdminPanel.PageMode)
    {
      BEditor.AdminPanel.PageMode.PageModeChanged.addHandler(showHideEditorToolBar);
    }
  }
}


module.exports =
{
  ToolbarsManager: ToolbarsManager
};